import React from 'react';

import './ButtonLink.scss';
import './ButtonLinkTypes';
import { ButtonLinkSize, ButtonLinkVariants } from './ButtonLinkTypes';

export default ({
  title,
  wrapperStyles,
  buttonStyles,
  variant = ButtonLinkVariants.primary,
  size = ButtonLinkSize.regular,
  href,
  className = '',
}) => {
  return (
    <div className={`button-link-wrapper ${size}`} style={wrapperStyles}>
      <a
        href={href}
        className={`button-link ${variant} ${size} ${className}`}
        style={buttonStyles}
        type='submit'
        rel="noreferrer noopener"
      >
        {title}
      </a>
    </div>
  );
};
